import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { OwlLogo } from '../ui/OwlLogo';

export function PublicLayout({ children }: { children: ReactNode }) {
  return (
    <div className="relative flex min-h-screen flex-col overflow-hidden bg-bg-soft">
      {/* Декоративный мягкий фон — Apple-style ambient gradient */}
      <div
        className="pointer-events-none absolute -top-40 left-1/2 h-[440px] w-[800px] -translate-x-1/2 rounded-full opacity-40 blur-3xl"
        style={{
          background:
            'radial-gradient(circle, rgba(255, 174, 66, 0.5), transparent 70%)',
        }}
        aria-hidden
      />
      <div
        className="pointer-events-none absolute -bottom-40 right-1/4 h-[360px] w-[520px] rounded-full opacity-30 blur-3xl"
        style={{
          background:
            'radial-gradient(circle, rgba(255, 102, 0, 0.4), transparent 70%)',
        }}
        aria-hidden
      />

      <header className="relative z-10 flex items-center justify-center px-4 pb-2 pt-8 animate-enter">
        <Link
          to="/login"
          className="inline-flex items-center gap-2 transition-transform hover:scale-[1.02]"
          aria-label="OnlyRead"
        >
          <OwlLogo size={48} />
          <span className="text-xl font-semibold tracking-tight text-text">
            OnlyRead
          </span>
        </Link>
      </header>
      <main className="relative z-10 flex flex-1 items-center justify-center px-4 pb-10">
        <div className="w-full max-w-md animate-enter-spring">{children}</div>
      </main>
    </div>
  );
}
